import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}
const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  ...props
}, ref) => {
  return <button ref={ref} className={cn('inline-flex items-center justify-center rounded-sm font-heading font-medium uppercase tracking-wider transition-all focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gold-500 disabled:pointer-events-none disabled:opacity-50', {
    'bg-gold-500 text-navy-900 hover:bg-white hover:text-navy-900': variant === 'primary',
    'bg-navy-700 text-white hover:bg-navy-600 border border-navy-600': variant === 'secondary',
    'border border-gold-500 text-gold-500 hover:bg-gold-500 hover:text-navy-900': variant === 'outline',
    'text-gold-500 hover:text-white hover:bg-navy-800': variant === 'ghost',
    'h-9 px-4 text-xs': size === 'sm',
    'h-12 px-8 text-sm': size === 'md',
    'h-14 px-10 text-base': size === 'lg'
  }, className)} {...props} data-id="element-370" />;
});
Button.displayName = 'Button';
export { Button };